import React, { useEffect } from "react";
import { useTexture } from "@react-three/drei";
import BlobGroup from "../groups/BlobGroup";
import AvatarGroup from "../groups/AvatarGroup";
import { useStore } from "../store";
import { Thumbnails, Presentation } from "../data/types";
import { PresentationContext } from "./Board";

export default function Scene() {
  const updatePersonas = useStore((state) => state["updatePersonas"]);
  const updateThumbnails = useStore((state) => state["updateThumbnails"]);
  const setBGAudio = useStore((state) => state["setBackgroundAudio"]);
  const context = React.useContext(PresentationContext) as unknown
  const presentation = context as Presentation


  useTexture(presentation.personas.map((persona) => persona.avatarFile))

  const thumbnailTextures = useTexture(presentation.personas.map((persona) => persona.cards).flat().map((card) => card.fullSizeFile));
  const thumbnails = thumbnailTextures.reduce((acc, curr) => {
    const { height, width, attributes } = curr.image
    acc[attributes[1].value as string] = { height, width }
    return acc
  }, {} as Thumbnails)

  useEffect(() => {
    updatePersonas(presentation.personas)
    updateThumbnails(thumbnails)
    setBGAudio(presentation.backgroundAudioFile)
  }, [thumbnails, updatePersonas, setBGAudio, updateThumbnails]);

  return (
    <>
      <BlobGroup />
      <AvatarGroup />
    </>
  );
}

